import { useQuery } from "@tanstack/react-query";

export interface SiteConfig {
  whatsappEnabled: boolean;
  whatsappNumber: string;
  whatsappLabel: string;
  phoneEnabled: boolean;
  phoneNumber: string;
  phoneLabel: string;
  internalChatEnabled: boolean;
  internalChatLabel: string;
  primaryCtaMode: string;
}

const defaultConfig: SiteConfig = {
  whatsappEnabled: true, whatsappNumber: "0", whatsappLabel: "WhatsApp Now",
  phoneEnabled: true, phoneNumber: "0", phoneLabel: "Call Discreetly",
  internalChatEnabled: true, internalChatLabel: "Chat Now",
  primaryCtaMode: "internal_chat",
};

export function useSiteConfig() {
  const { data } = useQuery<SiteConfig>({
    queryKey: ["/api/site-config"],
    staleTime: 1000 * 60 * 5,
  });
  return data || defaultConfig;
}
